import { render, staticRenderFns } from "./Chips.vue?vue&type=template&id=f6c9d23e&scoped=true"
import script from "./Chips.vue?vue&type=script&lang=js"
export * from "./Chips.vue?vue&type=script&lang=js"
import style0 from "./Chips.vue?vue&type=style&index=0&id=f6c9d23e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6c9d23e",
  null
  
)

export default component.exports